<template>
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.0693 9.94687C13.4045 10.2116 13.4254 10.7045 13.1318 10.9977L13.0693 11.0533L2.47559 19.4176C2.01321 19.7826 1.33309 19.4529 1.33301 18.8639V2.13632C1.33301 1.58419 1.93012 1.26011 2.38574 1.52206L2.47559 1.58261L13.0693 9.94687Z"
      stroke="white"
      stroke-opacity="0.5"
      stroke-width="1.66667"
    />
    <mask id="path-2-inside-1_439_1216" fill="white">
      <rect x="15.1152" y="0.5" width="5.38462" height="20" rx="1.53846" />
    </mask>
    <rect
      x="15.1152"
      y="0.5"
      width="5.38462"
      height="20"
      rx="1.53846"
      stroke="white"
      stroke-opacity="0.5"
      stroke-width="3.33333"
      mask="url(#path-2-inside-1_439_1216)"
    />
  </svg>
</template>
